import * as React from 'react'
import {Route, Switch} from 'react-router'
import {Redirect} from 'react-router-dom'

import {CONFIG_PATH} from 'constants/routes'

import {SitePage} from 'pages/site/SitePage.tsx'

export const ConfigIndexComponent: React.FC<any> = () => (
  <Switch>
    <Route path={`${CONFIG_PATH}/create`} render={() => <SitePage />} />
    <Route
      path={`${CONFIG_PATH}/:id/edit/:key`}
      render={(rp) => <SitePage id={+(rp.match.params.id as string)} activeKey={rp.match.params.key} />}
    />
    <Redirect from="/" to={`${CONFIG_PATH}/create`} />
  </Switch>
)
